import getApi from '../../api'

export const deleteMail = (id: string) => getApi().delete<void>(`/mss/messages/${id}`)
